<div class="m-2">
	<p-breadcrumb class="max-w-full" [model]="items" [home]="home">
		<ng-template #separator let-item>
			<i class="text-secondary fa-regular fa-angle-right"></i>
		</ng-template>
		<ng-template #item let-item>
			<ng-container *ngIf="item.route; else elseBlock">
				<a [routerLink]="item.route" class="p-breadcrumb-item-link">
					<span [ngClass]="[item.icon ? item.icon : '', 'text-secondary']"></span>
					<span class="whitespace-nowrap text-secondary">{{ item.label }}</span>
				</a>
			</ng-container>
			<ng-template #elseBlock>
				<span class="whitespace-nowrap text-secondary">{{ item.label }}</span>
			</ng-template>
		</ng-template>
	</p-breadcrumb>
</div>
